export const disptypedispatchtype = [
  { value: "1111", label: "1111", },
  { value: "1121", label: "1121", },
  { value: "1222", label: "1222", },
  { value: "2222", label: "2222", },
  { value: "2422", label: "2422", },
  { value: "3622", label: "3622", },
  { value: "4822", label: "4822", },
  { value: "1242", label: "1242", },
  { value: "2242", label: "2242", },
  { value: "1444", label: "1444", },
  { value: "2444", label: "2444", },
  { value: "3644", label: "3644", },
  { value: "4844", label: "4844", },
];

export const selectProducttype = [
  { value: "AdBlue", label: "AdBlue", },
  { value: "Fuel", label: "Fuel", },
];


export const selectcustomer = [
  { value: "IOCL", label: "IOCL", },
  { value: "BPCL", label: "BPCL", },
    { value: "HPCL", label: "HPCL", },
  { value: "RELIANCE", label: "RELIANCE", },
    { value: "SHELL", label: "SHELL", },
  { value: "PRIVATE", label: "PRIVATE", },
];


export const selectSitetype = [
  { value: "COCO", label: "Customer Owned Customer Operated (COCO)", },
  { value: "CODO", label: "Customer Owned Dealer Operated (CODO)", },
  { value: "DODO", label: "Dealer Owned Dealer Operated (DODO)", },
  { value: "Private", label: "Private", },
];

export const selectjobtype = [
  { value: "mail", label: "Mail", },
  // { value: "call", label: "Call", },
  { value: "message", label: "SMS", },
];


